import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';

export interface CanManageCapsulesResult {
  canManage: boolean;
  isSessionLoaded: boolean;
}

export function useCanManageCapsules(): CanManageCapsulesResult {
  const currentUser = useCurrentUser();
  const isSessionLoaded = currentUser.id != null;
  const canManage = isSessionLoaded && Boolean(currentUser.super_user || currentUser.isOrgAdmin);
  return { canManage, isSessionLoaded };
}
